<template>
  <div>
    <!-- 扫脸弹窗 -->
    <van-popup
      v-if="scanFaceVisible"
      v-model="scanFaceVisible"
      position="center"
      :class="_.scanFaceDialog"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <div :class="_.main">
        <img src="./images/order_selfpick_show_code/扫脸.png" :class="_.icon" />
        <div :class="_.tips">请将摄像头对准提货人进行人脸识别</div>
        <div :class="_.button" @click="handleScanFaceClick">开始识别</div>
      </div>
      <img
        src="./images/order_selfpick_show_code/关闭.png"
        :class="_.close"
        @click="scanFaceVisible = false"
      />
    </van-popup>

    <!-- 自提码弹窗 -->
    <van-popup
      v-if="selfPickCodeVisible"
      v-model="selfPickCodeVisible"
      position="center"
      :class="_.selfPickCodeDialog"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <div :class="_.main">
        <x-qrcode
          :value="selfPickCodeInfo.orderDetailUrl"
          :size="400"
          :class="_.qrcode"
        />
        <div :class="_.text">{{ selfPickCodeInfo.selfPickupCode }}</div>
      </div>
      <img
        src="./images/order_selfpick_show_code/关闭.png"
        :class="_.close"
        @click="selfPickCodeVisible = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import {
    apiOrderOrderSelfPickupGetSelfPickupCode,
    apiOrderOrderSelfPickupLiveCheck,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { submit } from '@/utils'

  export default {
    props: {
      // 条目
      item: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      scanFaceVisible: false,
      selfPickCodeVisible: false,
      selfPickCodeInfo: {},
    }),

    methods: {
      show() {
        this.handleShowSelfPickCodeClick()
      },
      // 点击出示自提码
      handleShowSelfPickCodeClick() {
        if (this.item.liveCheckFlag) {
          this.scanFaceVisible = true
        } else {
          this.doShowSelfPickCode()
        }
      },
      // 点击扫脸
      handleScanFaceClick() {
        this.doScanFace()
      },
      async doScanFace() {
        const { encryptedData, syncResult } =
          await dcb.requestFaceAuthentication()
        let token = encryptedData
        if (syncResult) {
          token = await dcb.requestFaceAuthResult({ code: encryptedData })
        }

        await apiOrderOrderSelfPickupLiveCheck({
          orderNo: this.item.orderNo,
          authToken: token,
        })
        this.scanFaceVisible = false
        this.doShowSelfPickCode()
      },
      doShowSelfPickCode() {
        submit(async $ => {
          $.start()
          const location = await dcb.getLocation({
            mustBeAuth: true,
          })
          const res = await apiOrderOrderSelfPickupGetSelfPickupCode({
            orderNo: this.item.orderNo,
            longitude: location.longitude,
            latitude: location.latitude,
            provinceName: location.province,
            provinceCode: location.provinceCode,
            cityName: location.city,
            cityCode: location.cityCode,
            districtName: location.district,
            districtCode: location.disCode,
            addressDetails: location.address,
          })
          this.selfPickCodeInfo = res
          this.selfPickCodeVisible = true
        })
      },
    },
  }
</script>

<style lang="scss" module>
  .scanFaceDialog {
    background-color: transparent !important;

    .main {
      width: 272px;
      height: 272px;
      background: #ffffff;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .icon {
        width: 110px;
        height: 110px;
      }

      .tips {
        margin-top: 16px;
        width: 195px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 22px;
        font-style: normal;
        text-align: center;
      }

      .button {
        margin-top: 12px;
        width: 222px;
        height: 50px;
        background: #16bbbf;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 17px;
        color: #ffffff;
        line-height: 24px;
        font-style: normal;

        &:active {
          filter: contrast(0.9) opacity(0.9);
        }
      }
    }

    .close {
      display: block;
      width: 32px;
      height: 32px;
      margin: auto;
      margin-top: 24px;
    }
  }

  .selfPickCodeDialog {
    background-color: transparent !important;

    .main {
      width: 272px;
      height: 272px;
      background: #ffffff;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .qrcode {
        width: 190px;
        height: 190px;
      }

      .text {
        margin-top: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 22px;
        font-style: normal;
      }
    }

    .close {
      display: block;
      width: 32px;
      height: 32px;
      margin: auto;
      margin-top: 24px;
    }
  }
</style>
